export interface RespondecoError<Error = Response, Types = string> {
  error: Error
  type: Types
}

export function isRespondecoError<T>(o: any): o is RespondecoError<T> {
  return 'error' in o && 'type' in o
}

export function wrap<T>(error: T | RespondecoError<T>, type: string): RespondecoError<T> {
  let wrappedError: RespondecoError<T>

  if (isRespondecoError(error)) {
    wrappedError = error
  } else {
    wrappedError = {
      error,
      type,
    }
  }

  return wrappedError
}
